import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services/index';
import { SealRingMaterialModel } from '../../../models/index';
import { Router } from '@angular/router';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-seal-ring-material',
    templateUrl: './seal-ring-material.component.html',
    styleUrls: ['./seal-ring-material.component.scss'],
    standalone: false,
})
export class SealRingMaterialComponent implements OnInit, OnDestroy {
    @Input()
    set manufacturerId(value: string) {
        if (value) {
            this._manufacturerId = value;
            if (!this.jointCalcService.isPipeCode) this.getSealRingMaterials();
        }
    }
    get manufacturerId(): string {
        return this._manufacturerId;
    }

    @Input()
    set hubMaterialId(value: string) {
        if (value) {
            this._hubMaterialId = value;
            if (!this.jointCalcService.isPipeCode) this.getSealRingMaterials();
        }
    }
    get hubMaterialId(): string {
        return this._hubMaterialId;
    }
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Output() selected: EventEmitter<SealRingMaterialModel> = new EventEmitter();
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    optionList: SealRingMaterialModel[] = [];
    private _manufacturerId: string;
    private _hubMaterialId: string;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit() {
        if (this.jointCalcService.isPipeCode && (this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView'))) {
            this.pipespecwithsealRingMaterial();
        }
        this.form
            .get('sealRingMaterial')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value)
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode)
                        this.jointCalcService.selectedsealRingMaterial.next(value);
            });
    }
    getSealRingMaterials(): void {
        if (!this.manufacturerId || !this.hubMaterialId) return;
        this.loading = true;

        this.iceapi
            .getSealRingMaterials(this.manufacturerId, this.hubMaterialId)
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((sealRingMaterials) => {
                if (sealRingMaterials.success === true) {
                    this.optionList = sealRingMaterials.response;
                    this.cd.markForCheck();
                    if (this.form.get('sealRingMaterial').value) {
                        this.dataService.selectedSealRingMaterial = this.optionList.find(
                            (x) => x.sealRingMaterialId === this.form.get('sealRingMaterial').value
                        ).name;
                    }
                    if (this.optionList.length === 1) this.form.get('sealRingMaterial').setValue(this.optionList[0].sealRingMaterialId);
                } else {
                    this.user_utility.errorModelPopup(sealRingMaterials.message);
                }
            });
    }

    selectSealRingMaterial(selectedValue: MatSelectChange): void {
        const selection = this.optionList.find((x) => x.sealRingMaterialId === selectedValue.value);
        if (selection) {
            this.selected.emit(selection);
            this.dataService.selectedSealRingMaterial = selection.name;
        }
    }

    async pipespecwithsealRingMaterial() {
        this.jointCalcService.selectedhubMaterial.pipe(takeUntil(this.destroy$)).subscribe(async (hb) => {
            if (hb) {
                const inputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;

                inputGroup.recordId.sealRingId = inputGroup.others.boltType = null;

                inputGroup.recordId.hubMaterialId = hb;
                this.loading = true;

                let pipesealRingMaterial = await this.iceapi
                    .getSealRingMaterials(inputGroup.recordId.manufacturerId, inputGroup.recordId.hubMaterialId)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();

                if (pipesealRingMaterial.success) {
                    this.optionList = [...pipesealRingMaterial.response];

                    this.optionList = await this.jointCalcService.managePayloadForRecourdId('sealRingMaterialId', this.optionList);

                    if (this.dataService?.calculationData?.input?.recordId?.sealRingMaterialId) {
                        this.form.get('sealRingMaterial').setValue(this.dataService?.calculationData?.input?.recordId?.sealRingMaterialId);
                    } else if (this.optionList.length === 1) this.form.get('sealRingMaterial').setValue(this.optionList[0].sealRingMaterialId);
                } else if (pipesealRingMaterial.isCustom) {
                    this.user_utility.errorModelPopup(pipesealRingMaterial.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
